const initialState = {
  winners: [],
  losers: [],
  remainingSurvivors: [],
  torchedSurvivors: [],
  activeTribalNumber: 0,
  totalTribalsCount: 0,
}

let stateHistory = [];
let votedOutOrder = [];

const applyRank = (selection, place) => {
return {
  ...selection,
  place: ordinal_suffix_of(place)
}
}

const nextWinnerScoreboard = (winners, sentHome) => {
// Find if sentHome on board
for (let i = 0; i < winners.length; i++) {
  if (winners[i].pick === sentHome) {
      // Find position of standing
      for (let j = winners.length - 1; j >= 0; j--) {
          if (winners[j].place === null) {
              return [
                  ...winners.slice(0, i),
                  ...winners.slice(i + 1, j + 1),
                  applyRank(winners.slice(i, i + 1)[0], j + 1),
                  ...winners.slice(j + 1)
              ]
          }
      }
  }
}
return winners
}

const nextLoserScoreboard = (losers, sentHome) => {
// Find if sentHome on board
for (let i = 0; i < losers.length; i++) {
  if (losers[i].pick === sentHome) {
      // Find position of standing
      for (let j = 0; j < losers.length; j++) {
          if (losers[j].place === null) {
              return [
                  ...losers.slice(0, j),
                  applyRank(losers.slice(i, i + 1)[0], j + 1),
                  ...losers.slice(j, i),
                  ...losers.slice(i + 1)
              ]
          }
      }
  }
}
return losers
}

const getNextWeek = (state) => {
if (state.activeTribalNumber + 2 < stateHistory.length)
  return stateHistory[state.activeTribalNumber + 1]
if (state.totalTribalsCount > state.activeTribalNumber) {
  const sentHome = votedOutOrder[state.activeTribalNumber]
  const torchedIndex = getSurvivorIndex(state.remainingSurvivors, sentHome)
  const newState = {
      ...state,
      torchedSurvivors: [
          ...state.remainingSurvivors.slice(torchedIndex, torchedIndex + 1),
          ...state.torchedSurvivors
      ],
      remainingSurvivors: [
          ...state.remainingSurvivors.slice(0, torchedIndex),
          ...state.remainingSurvivors.slice(torchedIndex + 1)
      ],
      winners: nextWinnerScoreboard(state.winners, sentHome),
      losers: nextLoserScoreboard(state.losers, sentHome),
      activeTribalNumber: state.activeTribalNumber + 1
  }
  stateHistory[state.activeTribalNumber + 1] = newState
  return newState
} else
  return state
}

const getFinalWeek = (state) => {
let nextWeek = getNextWeek(state)
if (nextWeek.activeTribalNumber >= nextWeek.totalTribalsCount) return nextWeek
else return getFinalWeek(nextWeek)
}

const getLastWeek = (state) => {
if (state.totalTribalsCount > 0)
  return stateHistory[state.activeTribalNumber - 1]
else
  return state
}

const getFirstWeek = (state) => {
return stateHistory[0]
}

const standings = (state = initialState, action) => {
switch (action.type) {
  case 'NEXT_WEEK':
      return getNextWeek(state)
  case 'LAST_WEEK':
      return getLastWeek(state)
  case 'FINAL_WEEK':
      return getFinalWeek(state)
  case 'FIRST_WEEK':
      return getFirstWeek(state)
  case 'INITIAL_SETUP':
      stateHistory = [action.state];
      votedOutOrder = action.outOrder;
      return action.state;
  default:
      return state
}
}

export default standings

function ordinal_suffix_of(i) {
var j = i % 10,
  k = i % 100;
if (j === 1 && k !== 11) {
  return i + "st";
}
if (j === 2 && k !== 12) {
  return i + "nd";
}
if (j === 3 && k !== 13) {
  return i + "rd";
}
return i + "th";
}

function getSurvivorIndex(survivors, name) {
for (let i = 0; i < survivors.length; i++) {
  if (survivors[i].name === name)
      return i
}
return -1
}
